import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-post.mjs";
import { render } from "lit-html";
import { B, downloadFile, isIOS, TOKENS } from "../../global.ts";
import { Post, Posts } from "../../../models/Posts.ts";
import { Functions } from "../../../managers/Functions.ts";
import { Media } from "../../../managers/Media.ts";
import { Me } from "../../../managers/Me.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";
import { HbMain } from "../hb-main.ts";

//import Strings from "../../../models/Strings.json";
//const strings: any = Strings;

export class HbPost extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private me = new Me();
    private media = new Media();
    private posts = new Posts();
    private functions = new Functions();
    private modal: ModalInterface;
    private main = document.querySelector("hb-main") as HbMain;

    private publication: HTMLElement;
    private archive: HTMLButtonElement;
    private cover: HTMLVideoElement;
    private views: HTMLSpanElement;

    private heading: HTMLSpanElement;
    private titleContainer: HTMLElement;
    private titleInput: HTMLInputElement;
    private titleMagic: HTMLButtonElement;
    private titlePaste: HTMLButtonElement;
    private titleTrash: HTMLButtonElement;

    private menu: HTMLElement;
    private pager: HTMLElement;
    private page: HTMLElement;
    private previous: HTMLButtonElement;
    private next: HTMLButtonElement;

    private photo: HTMLElement;
    private photoBtn: HTMLButtonElement;
    private photoFile: HTMLInputElement;
    private photoProgress: HTMLElement;
    private photoUpload: HTMLElement;
    private photoImageContainer: HTMLElement;
    private photoImage: HTMLImageElement;
    private photoRemove: HTMLButtonElement;
    private photoDownload: HTMLButtonElement;

    private short: HTMLElement;
    private shortBtn: HTMLButtonElement;
    private shortFile: HTMLInputElement;
    private shortProgress: HTMLElement;
    private shortUpload: HTMLElement;
    private shortVideoContainer: HTMLElement;
    private shortVideo: HTMLVideoElement;
    private shortRemove: HTMLButtonElement;
    private shortDownload: HTMLButtonElement;

    private ai: HTMLElement;
    private aiBtn: HTMLButtonElement;
    private prompt: HTMLInputElement;
    private promptBtn: HTMLButtonElement;
    private aiImage: HTMLImageElement;

    private from: HTMLSpanElement;
    private author: HTMLSpanElement;
    private story: HTMLTextAreaElement;
    private actions: HTMLElement;
    private magic: HTMLButtonElement;
    private paste: HTMLButtonElement;
    private trash: HTMLButtonElement;

    private footer: HTMLElement;
    private footerDate: HTMLSpanElement;
    private form: HTMLFormElement;
    private publishBtn: HTMLButtonElement;
    private externalBtns: HTMLElement;
    private shareBtn: HTMLButtonElement;
    private copyBtn: HTMLButtonElement;

    private footerContainer: HTMLElement;
    private thank: HTMLButtonElement;
    private tokens: HTMLElement;

    private aiItem = 0;
    private aiCount = 0;

    private hasPasskey = false;
    private post: Post | null = null;
    private type: "photo" | "short" | "ai" | "none" = "none";

    constructor() {
        super();
        render(template(null), this);

        this.publication = this.querySelector("#hb-post")!;
        this.archive = this.querySelector("#hb-post-archive")!;
        this.cover = this.querySelector("#hb-post-cover")!;
        this.views = this.querySelector("#hb-post-views")!;

        this.heading = this.querySelector("#hb-post-heading")!;
        this.titleContainer = this.querySelector("#hb-post-title-container")!;
        this.titleInput = this.querySelector("#hb-post-title")!;
        this.titleMagic = this.querySelector("#hb-post-title-magic")!;
        this.titlePaste = this.querySelector("#hb-post-title-paste")!;
        this.titleTrash = this.querySelector("#hb-post-title-trash")!;

        this.menu = this.querySelector("#hb-post-menu")!;
        this.pager = this.querySelector("#hb-post-menu-pager")!;
        this.page = this.querySelector("#hb-post-menu-page")!;
        this.previous = this.querySelector("#hb-post-menu-previous")!;
        this.next = this.querySelector("#hb-post-menu-next")!;

        this.photo = this.querySelector("#hb-post-photo")!;
        this.photoBtn = this.querySelector("#hb-post-menu-photo")!;
        this.photoFile = this.querySelector("#hb-post-photo-file")!;
        this.photoProgress = this.querySelector("#hb-post-photo-progress")!;
        this.photoUpload = this.querySelector("#hb-post-photo-upload")!;
        this.photoImage = this.querySelector("#hb-post-photo-image")!;
        this.photoRemove = this.querySelector("#hb-post-photo-remove")!;
        this.photoImageContainer = this.photoImage.parentElement as HTMLElement;
        this.photoDownload = this.querySelector("#hb-post-photo-download")!;

        this.short = this.querySelector("#hb-post-short")!;
        this.shortBtn = this.querySelector("#hb-post-menu-short")!;
        this.shortFile = this.querySelector("#hb-post-short-file")!;
        this.shortProgress = this.querySelector("#hb-post-short-progress")!;
        this.shortUpload = this.querySelector("#hb-post-short-upload")!;
        this.shortVideo = this.querySelector("#hb-post-short-video")!;
        this.shortRemove = this.querySelector("#hb-post-short-remove")!;
        this.shortVideoContainer = this.shortVideo.parentElement as HTMLElement;
        this.shortDownload = this.querySelector("#hb-post-short-download")!;

        this.ai = this.querySelector("#hb-post-ai")!;
        this.aiBtn = this.querySelector("#hb-post-menu-ai")!;
        this.prompt = this.querySelector("#hb-post-ai-prompt")!;
        this.promptBtn = this.querySelector("#hb-post-ai-magic")!;
        this.aiImage = this.querySelector("#hb-post-ai-image")!;

        this.from = this.querySelector("#hb-post-story-from")!;
        this.author = this.querySelector("#hb-post-story-author")!;
        this.story = this.querySelector("#hb-post-story")!;
        this.actions = this.querySelector("#hb-post-story-actions")!;
        this.magic = this.querySelector("#hb-post-story-magic")!;
        this.paste = this.querySelector("#hb-post-story-paste")!;
        this.trash = this.querySelector("#hb-post-story-trash")!;

        this.footer = this.querySelector("#hb-post-footer")!;
        this.footerDate = this.querySelector("#hb-post-footer-date")!;
        this.form = this.querySelector("#hb-post-form")!;
        this.publishBtn = this.querySelector("#hb-post-publish")!;
        this.externalBtns = this.querySelector("#hb-post-external")!;
        this.shareBtn = this.querySelector("#hb-post-share")!;
        this.copyBtn = this.querySelector("#hb-post-copy")!;

        this.footerContainer = this.externalBtns.parentElement as HTMLElement;
        this.thank = this.querySelector("#hb-post-thank")!;
        this.tokens = this.querySelector("#hb-post-tokens")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                this.cover.muted = true;
                this.shortVideo.muted = true;
                //window.location.hash = "#";
            },
            onShow: () => {
                // need user interaction
                //if (this.stockImage.paused) this.stockImage.play();
                //if (this.aiImage.paused) this.aiImage.play();
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-post",
            override: true
        };

        this.modal = new Modal(this.publication, modalOptions, instanceOptions);
    }

    connectedCallback() {
        this.addTitleListeners();
        this.addPhotoListeners();
        this.addShortListeners();
        this.addAIListeners();
        this.addStoryListeners();
        this.addFooterListeners();

        this.archive.addEventListener("click", () =>
            alert("B-Sticker and B-History coming soon!")
        );

        this.thank.addEventListener("click", async () => {
            this.footerContainer.classList.add("hidden");
            this.thank.classList.add("hidden");
            this.tokens.classList.remove("hidden");
            this.publication.scrollTo({
                top: this.publication.scrollHeight,
                behavior: "smooth"
            });
        });

        this.heartbank.addAuthStateListener(async (user) => {
            render(template(user), this);
            if (user)
                this.hasPasskey = (await this.heartbank.passKeysCount()) > 0;
        });
    }

    private resetMenu() {
        this.photoBtn.classList.remove("underline", "uppercase");
        this.shortBtn.classList.remove("underline", "uppercase");
        this.aiBtn.classList.remove("underline", "uppercase");

        this.photo.classList.add("hidden");
        this.short.classList.add("hidden");
        this.ai.classList.add("hidden");

        this.pager.classList.add("hidden");
        this.pager.classList.remove("inline-flex");
    }

    private addPhotoListeners() {
        this.photoBtn.addEventListener("click", () => {
            this.type = "photo";
            this.resetMenu();
            this.photoBtn.classList.add("underline", "uppercase");
            this.photo.classList.remove("hidden");
        });

        this.photoFile.addEventListener("change", async () => {
            if (this.heartbank.user && this.hasPasskey) {
                this.main.showSpinner();
                this.photoFile.disabled = true;
                if (this.photoFile.files && this.photoFile.files.length > 0) {
                    const progress = this.photoProgress
                        .parentElement as HTMLElement;
                    this.photoProgress.style.width = "0%";
                    this.photoProgress.textContent = "0%";
                    progress.classList.remove("hidden");
                    try {
                        const photo = await this.media.createPhotoFromFile(
                            this.photoFile.files[0]
                        );
                        this.photoImage.src = await this.media.storeFile(
                            photo.name,
                            photo,
                            (percent) => {
                                this.photoProgress.style.width = percent + "%";
                                this.photoProgress.textContent = `${percent}%`; // Uploading:
                            }
                        );
                        localStorage.setItem("post-photo", this.photoImage.src);
                        this.photoImageContainer.classList.remove("hidden");
                        this.photoUpload.classList.add("hidden");
                    } catch (error: any) {
                        alert(error.message);
                    } finally {
                        progress.classList.add("hidden");
                    }
                }
                this.photoFile.disabled = false;
                this.main.hideSpinner();
            } else {
                if (this.heartbank.user) {
                    if (
                        confirm(
                            "Passkey is required to share a B-Post.\n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-lockbox",
                            window.location.hash
                        );
                        window.location.hash = "#/lockbox";
                    }
                } else {
                    if (
                        confirm(
                            "You need to be logged in to share a B-Post.\n\nWould you like to log in now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-login",
                            window.location.hash
                        );
                        window.location.hash = "#/login";
                    }
                }
            }
        });

        this.photoDownload.addEventListener("click", async () => {
            this.photoDownload.disabled = true;
            await downloadFile("B-Photo", this.photoImage.src); // extension auto added
            this.photoDownload.disabled = false;
        });

        this.photoRemove.addEventListener("click", async () => {
            if (confirm("Would you like to remove this photo?")) {
                this.main.showSpinner();
                this.photoRemove.disabled = true;

                await this.media.removeFile(this.photoImage.src);
                localStorage.removeItem("post-photo");
                this.photoFile.value = "";
                this.photoImageContainer.classList.add("hidden");
                this.photoUpload.classList.remove("hidden");

                this.photoRemove.disabled = false;
                this.main.hideSpinner();
            }
        });
    }

    private addShortListeners() {
        this.shortBtn.addEventListener("click", () => {
            this.type = "short";
            this.resetMenu();
            this.shortBtn.classList.add("underline", "uppercase");
            this.short.classList.remove("hidden");
        });

        this.shortFile.addEventListener("change", async () => {
            if (this.heartbank.user && this.hasPasskey) {
                this.main.showSpinner();
                this.shortFile.disabled = true;
                if (this.shortFile.files && this.shortFile.files.length > 0) {
                    const progress = this.shortProgress
                        .parentElement as HTMLElement;
                    this.shortProgress.style.width = "0%";
                    this.shortProgress.textContent = "0%";
                    progress.classList.remove("hidden");
                    try {
                        const short = this.shortFile.files[0];
                        const result =
                            await this.media.validateVideoFile(short);
                        if (result.isValid && result.poster) {
                            this.shortVideo.poster = await this.media.storeFile(
                                result.poster.name,
                                result.poster,
                                (percent) => {
                                    this.shortProgress.style.width =
                                        percent + "%";
                                    this.shortProgress.textContent = `${percent}%`; // Uploading poster:
                                }
                            );
                            localStorage.setItem(
                                "post-poster",
                                this.shortVideo.poster
                            );
                            this.shortVideo.src = await this.media.storeFile(
                                short.name,
                                short,
                                (percent) => {
                                    this.shortProgress.style.width =
                                        percent + "%";
                                    this.shortProgress.textContent = `${percent}%`; // Uploading video:
                                }
                            );
                            localStorage.setItem(
                                "post-short",
                                this.shortVideo.src
                            );
                            this.shortVideoContainer.classList.remove("hidden");
                            this.shortUpload.classList.add("hidden");
                        } else alert(result.errorMessage);
                    } catch (error: any) {
                        alert(error.message);
                    } finally {
                        progress.classList.add("hidden");
                    }
                }
                this.shortFile.disabled = false;
                this.main.hideSpinner();
            } else {
                if (this.heartbank.user) {
                    if (
                        confirm(
                            "Passkey is required to share a B-Post.\n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-lockbox",
                            window.location.hash
                        );
                        window.location.hash = "#/lockbox";
                    }
                } else {
                    if (
                        confirm(
                            "You need to be logged in to share a B-Post.\n\nWould you like to log in now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-login",
                            window.location.hash
                        );
                        window.location.hash = "#/login";
                    }
                }
            }
        });

        this.shortDownload.addEventListener("click", async () => {
            this.shortDownload.disabled = true;
            await downloadFile("B-Short", this.shortVideo.src); // extension auto added
            this.shortDownload.disabled = false;
        });

        this.shortRemove.addEventListener("click", async () => {
            if (confirm("Would you like to remove this short?")) {
                this.main.showSpinner();
                this.shortRemove.disabled = true;

                await this.media.removeFile(this.shortVideo.poster);
                await this.media.removeFile(this.shortVideo.src);
                localStorage.removeItem("post-poster");
                localStorage.removeItem("post-short");
                this.shortFile.value = "";
                this.shortVideoContainer.classList.add("hidden");
                this.shortUpload.classList.remove("hidden");

                this.shortRemove.disabled = false;
                this.main.hideSpinner();
            }
        });
    }

    private addAIListeners() {
        this.aiBtn.addEventListener("click", () => {
            this.type = "ai";
            this.resetMenu();
            this.aiBtn.classList.add("underline", "uppercase");
            this.ai.classList.remove("hidden");
            //this.menu.classList.remove("hidden");
            //this.pager.classList.add("inline-flex");
            //this.prompt.focus();
        });

        this.previous.addEventListener("click", () => {
            this.goToAI(false);
        });

        this.next.addEventListener("click", () => {
            this.goToAI(true);
        });
    }

    private addStoryListeners() {
        this.story.addEventListener("input", () => {
            localStorage.setItem("post-story", this.story.value);
        });

        this.magic.addEventListener("click", () => {
            if (
                confirm(
                    "Would you like Miss Aquarius™ AI to improve your writing?"
                )
            ) {
                alert("AI writing assistant coming soon...");
            }
        });

        this.paste.addEventListener("click", async () => {
            if (
                this.story.value.trim() === "" ||
                confirm(
                    "Would you like to replace your writing with the one you copied to your clipboard?"
                )
            ) {
                this.story.value = await navigator.clipboard.readText();
                localStorage.setItem("post-story", this.story.value);
                this.story.focus();
            }
        });

        this.trash.addEventListener("click", () => {
            if (
                this.story.value &&
                confirm("Would you like to clear your writing and start over?")
            ) {
                this.story.value = "";
                localStorage.setItem("post-story", this.story.value);
                this.story.focus();
            }
        });
    }

    private addTitleListeners() {
        this.titleInput.addEventListener("input", () => {
            localStorage.setItem("post-title", this.titleInput.value);
        });

        this.titleMagic.addEventListener("click", () => {
            if (
                confirm(
                    "Would you like Miss Aquarius™ AI to improve your title?"
                )
            ) {
                alert("AI title assistant coming soon...");
            }
        });

        this.titlePaste.addEventListener("click", async () => {
            if (
                this.titleInput.value.trim() === "" ||
                confirm(
                    "Would you like to replace your title with the one you copied to your clipboard?"
                )
            ) {
                this.titleInput.value = await navigator.clipboard.readText();
                localStorage.setItem("post-title", this.titleInput.value);
                this.titleInput.focus();
            }
        });

        this.titleTrash.addEventListener("click", () => {
            if (
                this.titleInput.value &&
                confirm("Would you like to clear your title and start over?")
            ) {
                this.titleInput.value = "";
                localStorage.setItem("post-title", this.titleInput.value);
                this.titleInput.focus();
            }
        });
    }

    private getPhoto() {
        switch (this.type) {
            case "photo":
                return this.photoImage.src;
            case "short":
                return this.shortVideo.poster;
            case "ai":
                return ""; //this.aiImage.src;
            case "none":
                return "";
        }
    }

    private getShort() {
        switch (this.type) {
            case "photo":
                return "";
            case "short":
                return this.shortVideo.src;
            case "ai":
                return "";
            case "none":
                return "";
        }
    }

    private getType() {
        switch (this.type) {
            case "photo":
                return localStorage.getItem("post-photo") ? "photo" : "none";
            case "short":
                return localStorage.getItem("post-short") ? "short" : "none"; // check post-poster ?
            case "ai":
                return "none";
            case "none":
                return "none";
        }
    }

    private async cleanUp() {
        const photo = localStorage.getItem("post-photo");
        const poster = localStorage.getItem("post-poster");
        const short = localStorage.getItem("post-short");

        switch (this.type) {
            case "photo":
                if (poster) await this.media.removeFile(poster);
                if (short) await this.media.removeFile(short);
                break;
            case "short":
                if (photo) await this.media.removeFile(photo);
                break;
            case "ai":
                if (photo) await this.media.removeFile(photo);
                if (poster) await this.media.removeFile(poster);
                if (short) await this.media.removeFile(short);
                break;
            case "none":
                if (photo) await this.media.removeFile(photo);
                if (poster) await this.media.removeFile(poster);
                if (short) await this.media.removeFile(short);
                break;
        }

        localStorage.removeItem("post-title");
        localStorage.removeItem("post-photo");
        localStorage.removeItem("post-poster");
        localStorage.removeItem("post-short");
        localStorage.removeItem("post-story");

        this.photoImageContainer.classList.add("hidden");
        this.photoUpload.classList.remove("hidden");
        this.shortVideoContainer.classList.add("hidden");
        this.shortUpload.classList.remove("hidden");
    }

    private addFooterListeners() {
        //this.form.addEventListener("submit", async (event) => { // buggy with required
        this.publishBtn.addEventListener("click", async (event) => {
            event.preventDefault();
            if (this.post) {
                window.location.hash = "#/post";
            } else {
                if (!this.titleInput.value.trim()) {
                    this.titleInput.reportValidity();
                    return;
                }
                // if (!this.story.value.trim()) {
                //     this.story.reportValidity();
                //     return;
                // }

                this.main.showSpinner();
                this.publishBtn.disabled = true;
                if (this.heartbank.user && this.hasPasskey) {
                    const response = await this.posts.publish(
                        this.titleInput.value.trim().capitalize(),
                        this.story.value.trim(),
                        this.getPhoto(),
                        this.getShort(),
                        this.getType()
                    );
                    if (response.data) {
                        await this.cleanUp();
                        alert(
                            `🎉 You have successfully published this B-Post to the Aquarius™ Blockchain!\n\n🌎 You can now share it with the world!\n\nNOTE: Your followers have been notified by email`
                        );
                        window.location.hash = `#/post/${response.data.id}`;
                    } else if (response.color === "red") alert(response.text);
                } else {
                    if (this.heartbank.user) {
                        if (
                            confirm(
                                "Passkey is required to publish a B-Post.\n\nWould you like to create one now?"
                            )
                        ) {
                            localStorage.setItem(
                                "redirect-lockbox",
                                window.location.hash
                            );
                            window.location.hash = "#/lockbox";
                        }
                    } else {
                        if (
                            confirm(
                                "You need to be logged in to publish a B-Post.\n\nWould you like to log in now?"
                            )
                        ) {
                            localStorage.setItem(
                                "redirect-login",
                                window.location.hash
                            );
                            window.location.hash = "#/login";
                        }
                    }
                }
                this.publishBtn.disabled = false;
                this.main.hideSpinner();
            }
        });

        this.shareBtn.addEventListener("click", this.share.bind(this));

        this.copyBtn.addEventListener("click", async (event) => {
            await navigator.clipboard.writeText(this.getText(false));
            alert("This B-Post has been copied to your clipboard!");
        });
    }

    // TODO: show spinner if await is too long
    async show(id: string) {
        this.main.showSpinner();
        if (id) {
            this.post = await this.posts.get(id);
            if (this.post) {
                const views = this.views.firstElementChild as HTMLSpanElement;
                const digs = this.post.digs || 0;
                const scans = this.post.scans || 0;
                views.textContent = (digs + scans).toString();

                this.views.classList.remove("hidden");
                this.menu.classList.add("hidden");
                this.archive.classList.add("hidden");

                this.heading.classList.remove("hidden");
                this.titleContainer.classList.add("hidden");
                this.heading.textContent = this.post.title;

                this.resetMenu();
                if (this.post.photo) {
                    this.cover.poster = this.post.photo;
                    this.cover.classList.remove("hidden");
                } else {
                    this.cover.removeAttribute("poster");
                    this.cover.classList.add("hidden");
                }
                if (this.post.short) {
                    this.cover.src = this.post.short;
                    this.cover.controls = true;

                    this.cover.removeAttribute("controlsList");
                    this.cover.style.pointerEvents = "";
                    this.cover.onclick = () => {};
                } else {
                    this.cover.removeAttribute("src");
                    this.cover.controls = false;
                    this.cover.load(); // needed to clear previous video

                    this.cover.setAttribute(
                        "controlsList",
                        "nodownload nofullscreen noremoteplayback"
                    );
                    this.cover.style.pointerEvents = "none";
                    this.cover.onclick = () => this.cover.pause();
                }

                this.actions.classList.add("hidden");
                this.author.innerHTML = `<hb-me class="ml-0" uid="${this.post.author}"></hb-me>`;
                this.from.classList.remove("hidden");

                this.story.placeholder = "Empty Story";
                this.story.value = this.post.story; // optional: ""
                this.story.disabled = true;
                this.story.classList.add(
                    "text-center",
                    "leading-loose",
                    "font-cursive",
                    "text-2xl",
                    "h-56"
                );
                this.story.classList.remove("text-lg", "h-40");

                this.footerDate.textContent =
                    "Published on " +
                    this.post.date.toDate().toFormattedString();
                this.footer.classList.remove("hidden");
                this.footer.classList.add("flex");

                this.externalBtns.classList.remove("hidden");
                this.publishBtn.textContent = "Publish New B-Post";

                const author = await this.me.getName3(this.post.author);
                this.thank.innerHTML = `Thank <strong>${author}</strong>`;
                this.thank.classList.toggle(
                    "hidden",
                    this.post.author === this.heartbank.user?.uid
                );
                this.renderTokens(this.post.author, author, this.post.title);

                // stats
                this.posts.addMiner(this.heartbank.user?.uid || "", id);
            } else window.location.hash = "#/post";
        } else {
            this.post = null;

            this.views.classList.add("hidden");
            this.menu.classList.remove("hidden");
            this.archive.classList.remove("hidden");
            this.heading.classList.add("hidden");
            this.titleContainer.classList.remove("hidden");
            this.titleInput.value = localStorage.getItem("post-title") || "";

            const photo = localStorage.getItem("post-photo");
            if (photo) {
                this.photoImage.src = photo;
                this.photoImageContainer.classList.remove("hidden");
                this.photoUpload.classList.add("hidden");
            } else {
                this.photoImage.removeAttribute("src");
            }

            const poster = localStorage.getItem("post-poster");
            const short = localStorage.getItem("post-short");
            if (poster || short) {
                if (poster) this.shortVideo.poster = poster;
                if (short) this.shortVideo.src = short;
                this.shortVideo.controls = true;
                this.shortVideoContainer.classList.remove("hidden");
                this.shortUpload.classList.add("hidden");
            } else {
                this.shortVideo.removeAttribute("poster");
                this.shortVideo.removeAttribute("src");
            }

            this.photoBtn.click();
            //this.shortBtn.click();
            this.cover.classList.add("hidden");

            this.actions.classList.remove("hidden");
            this.author.innerHTML = "🩵 Story";
            this.from.classList.add("hidden");

            this.story.placeholder =
                "Optional: Write your story here to publish on the Aquarius™ Blockchain — freely and forever assessible to all humans and AI agents";
            this.story.value = localStorage.getItem("post-story") || "";
            this.story.disabled = false;
            this.story.classList.remove(
                "text-center",
                "leading-loose",
                "font-cursive",
                "text-2xl",
                "h-56"
            );
            this.story.classList.add("text-lg", "h-40");
            this.footer.classList.add("hidden");
            this.footer.classList.remove("flex");
            this.externalBtns.classList.add("hidden");
            this.publishBtn.textContent = "Publish B-Post";
            this.thank.classList.add("hidden");
        }

        this.footerContainer.classList.remove("hidden");
        this.tokens.classList.add("hidden");
        this.modal.show();
        this.main.hideSpinner();
    }

    private renderTokens(uid: string, name: string, title: string) {
        this.tokens.innerHTML = "";

        // cancel
        const button = document.createElement("button");
        button.type = "button";
        button.className = `text-white bg-sky-900 focus:ring-4 focus:outline-none font-medium rounded-lg text-base w-full px-5 py-2.5 text-center`;
        button.innerHTML = `Cancel`;
        button.onclick = () => {
            this.footerContainer.classList.remove("hidden");
            this.thank.classList.remove("hidden");
            this.tokens.classList.add("hidden");
        };
        this.tokens.appendChild(button);

        for (const token of TOKENS) {
            const button = document.createElement("button");
            button.type = "button";
            //button.dataset.token = token.token;
            button.className = `text-white ${token.color} focus:ring-4 focus:outline-none font-medium rounded-lg text-base w-full px-5 py-2.5 text-center`;
            button.innerHTML = `Give ${token.emoji} B-Token to <strong>${name}</strong>`;
            button.onclick = () => {
                localStorage.setItem(
                    "token-gold",
                    `Thanks so much for writing a great post about "${title}"`
                );
                window.location.hash = `#/token/${token.token}/${uid}/0/0`;
            };
            this.tokens.appendChild(button);
        }
    }

    hide() {
        this.modal.hide();
    }

    private goToAI(direction: boolean) {}

    private getUrl() {
        return `${B}/p/${this.post!.id}`;
    }

    private getText(isShare: boolean) {
        const header = this.post?.story
            ? `🩵 HeartBank® Post: ${this.post?.title}\n\n`
            : "🩵 HeartBank® Post\n\n";

        const footer = "❤️ Humanity Proof by HeartBank®"; // \n\n➡️ Publish your own B-Post here: https://vault.333.eco/#/post

        const story = (this.post?.story || this.post?.title) + "\n\n";
        const url = isShare ? "" : this.getUrl() + "\n\n";

        return header + story + url + footer;
    }

    //TODO: later get avatar beating heart
    private async getFile() {
        // let file: File | null = null;
        // if (
        //     isIOS &&
        //     !this.thank?.to &&
        //     (this.thank?.type === "photo" || this.thank?.type === "short")
        // ) {
        //     const response = await fetch(this.stockImage.src); // `${TREASURY}/${this.stockCategory}/${this.stockItem}/${this.stockItem}.gif`
        //     const blob = await response.blob();
        //     file = new File([blob], "B-Thank.gif", { type: "image/gif" });
        // }
        // return file ? [file] : [];
        return [];
    }

    private async share(event: Event) {
        event.preventDefault();
        this.shareBtn.disabled = true;

        const shareData = {
            title: "HeartBank® Post",
            text: this.getText(true),
            url: this.getUrl(),
            files: await this.getFile()
        };
        //console.log(shareData);

        if (navigator.canShare && navigator.canShare(shareData)) {
            try {
                await navigator.share(shareData);
                console.log("Shared successfully");
            } catch (error: any) {
                if (
                    error.name === "AbortError" ||
                    error.name === "InvalidStateError"
                ) {
                    console.warn("Sharing was cancelled:", error);
                } else {
                    console.error(error);
                }
            }
        } else {
            alert("Sorry, Web Share is not supported on this device.");
        }

        this.shareBtn.disabled = false;
    }
}
